export const messages = {
  en: {
    adminGroup: {
      searchCondition: 'Search Condition',
      inputProductName: 'Please input product name',
      search: 'Search',
      shopGroup: 'Shop Group',
      id: 'ID',
      productImage: 'Product Image',
      productName: 'Product Name',
      groupPeople: 'Group People',
      groupPrice: 'Group Price',
      singlePrice: 'Single Price',
      status: 'Status',
      validity: 'Validity',
      isRebate: 'Is Rebate',
      leaderRebate: 'Leader Rebate',
      enable: 'Enable',
      disable: 'Disable',
      yes: 'Yes',
      no: 'No'
    }
  },
  zh: {
    adminGroup: {
      searchCondition: '查询条件',
      inputProductName: '请输入商品名称',
      search: '查询',
      shopGroup: '店铺拼团',
      id: '编号',
      productImage: '商品图片',
      productName: '商品名称',
      groupPeople: '拼团人数',
      groupPrice: '拼团金额',
      singlePrice: '单买金额',
      status: '状态',
      validity: '有效期',
      isRebate: '是否返佣',
      leaderRebate: '团长返佣',
      enable: '启用',
      disable: '停用',
      yes: '是',
      no: '否'
    }
  }
}